export const strings = {
  shopify: {
    welcomeTitle: 'Vielen Dank für Ihre Bestellung!',
    welcomeSubtitle: 'Erstellen Sie Ihr Konto, um mit Ihrem Test zu beginnen.'
  },
  upTo: 'Unter',
  redirecting: 'Unter der Regie von...',
  startingFrom: 'von',
  consultation: '+ Beratung',
  written: '+ Kommentar',
  error: {
    required: 'Muss angenommen werden',
    RequiredFillOut: 'Muss ausgefüllt werden',
    quotaReached: {
      title: 'Heute leider keine kostenlosen Tests',
      description: 'Wir laden Sie ein, es morgen zu versuchen'
    },
    feedback: {
      title: 'Wir bedauern, dass ein Fehler aufgetreten ist',
      description: 'Hinterlassen Sie bitte eine Bewertung für später'
    },
    common: {
      title: 'Wir bedauern, dass ein Fehler aufgetreten ist',
      description: 'Bitte versuchen Sie es später noch einmal'
    },
    pageNotFound: {
      title: 'Website nicht gefunden',
      description: 'Bitte überprüfen Sie die Adresse der Website und versuchen Sie es erneut.',
      goHome: 'Zurück zum Anfang'
    },
    fieldIsRequired: 'Dieses Feld ist erforderlich',
    youMustSelect: 'Optional',
    terms: {
      required: 'Die Akzeptanz der Nutzungsbedingungen ist erforderlich'
    },
    agreeResearch: {
      required:
        'Wenn Sie damit nicht einverstanden sind, können wir Sie nicht testen und keine Empfehlungen aussprechen.'
    },
    agreementForScienceResearch: {
      required:
        'Wenn Sie damit nicht einverstanden sind, können wir Sie nicht testen und keine Empfehlungen aussprechen.'
    },
    selectedPatientId: {
      required: 'Die Wahl des Patienten ist erforderlich'
    },
    firstName: {
      required: 'Name ist erforderlich'
    },
    lastName: {
      required: 'Nachname ist erforderlich'
    },
    email: {
      required: 'E-Mail Adresse ist erforderlich',
      isUsed:
        'Unter dieser E-Mail-Adresse wurde bereits ein Benutzer angelegt. Bitte benutzen Sie das Anmeldeformular oder verwenden Sie eine andere E-Mail-Adresse.'
    },
    phone: {
      required: 'Telefon ist erforderlich',
      invalid: 'Geben Sie eine Rufnummer ein, z. B. +49...'
    },
    bank: {
      required: 'Wählen Sie Ihre Zahlungsmethode'
    },
    password: {
      minLength: 'Das Passwort muss mindestens {length} Zeichen haben',
      same: 'Passwörter müssen übereinstimmen'
    },
    birthDate: {
      required: 'Geburtsdatum erforderlich'
    },
    gender: {
      required: 'Die Angabe des Geschlechts ist erforderlich'
    },
    personCode: {
      required: 'Persönliche Identifikationsnummer erforderlich',
      incorrect: 'Geben Sie Ihre persönliche Identifikationsnummer ein. Der von Ihnen eingegebene Code ist falsch.',
      length: 'Muss elf Zeichen lang sein'
    },
    agreeRemoteConsultation: {
      required: 'Wenn Sie damit nicht einverstanden sind, können wir Ihnen keine Fernberatungen anbieten.'
    },
    agreeChildResponsibility: {
      required: 'Sie müssen eine bevollmächtigte Person sein, um Ihr Kind anzumelden.'
    },
    agreeTerms: {
      required: 'Es ist notwendig, die Nutzungsbedingungen zu akzeptieren'
    },
    YourChildCode: {
      required: 'Persönliche Identifikationsnummer erforderlich'
    },
    address: {
      required: 'Die Angabe einer Adresse ist erforderlich'
    },
    backendError: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.',
    valueMustBeAtLeast: 'Der Wert muss mindestens betragen'
  },
  loading: {
    wait: 'Bitte warten...',
    wait_until_check: 'Bitte warten Sie, bis wir eine Zahlungsbestätigung von Ihrer Bank erhalten.',
    wait_until_sign_check: 'Warten auf die Bestätigung der Unterzeichnung des Dokuments'
  },
  button: {
    close: 'Schließen',
    continue: 'Weiter',
    start: 'Start bei',
    goBack: 'Zurückgehen',
    buy: 'Kaufen bei',
    order: 'Bestellung von',
    understood: 'Verstanden.',
    pay: 'Bezahlen',
    completedOrder: 'Bestellung von',
    check: 'Anwenden',
    login: 'Einloggen',
    preview: 'Ansicht unter',
    createAccount: 'Ein Konto erstellen',
    createPatient: 'Den Patienten anlegen',
    sendReminder: 'Erinnerung senden',
    changePassword: 'Passwort ändern',
    signOrder: 'Anmeldung',
    send: 'Senden',
    upload: 'Hochladen',
    complete: 'Oberfläche',
    pdf: 'PDF herunterladen',
    generatePdf: 'PDF erstellen',
    generatingPdf: 'Wird erstellt...',
    generatingPdfInfo:
      'Ihre PDF wird automatisch heruntergeladen, sobald die Erstellung abgeschlossen ist. Dies dauert normalerweise 1-2 Minuten.',
    startQuestionnaire: 'Füllen Sie den Fragebogen aus',
    download: 'Herunterladen',
    save: 'Speichern und fortfahren'
  },
  products: {
    CONSULTATION: {
      allergens: '0',
      title: 'Fernberatung durch einen Allergologen',
      titleResearch: '',
      titleProduct6month: '',
      orderTitle: 'Buchen Sie eine Fernberatung',
      description:
        'Das Gespräch umfasst eine Bewertung der Symptome und der Wahrscheinlichkeit, dass sie durch Allergien verursacht werden. Es werden Tests durchgeführt, und es wird ein erster Behandlungsplan erstellt.',
      bullets: [
        'Schriftliche Beurteilung und Empfehlungen durch einen Allergologen',
        'Gelegenheit, zusätzliche Fragen zu stellen',
        '20-minütiges Videogespräch mit einem Allergologen'
      ]
    },
    FULL: {
      allergens: '295',
      title: 'Umfassendes Programm für Allergietests',
      titleResearch: '',
      titleProduct6month: '',
      orderTitle: 'Buchen Sie eine vollständige Untersuchung',
      description:
        'In der Studie wird die Sensibilisierung auf fast 300 Allergene untersucht, darunter praktisch alle Allergene, die allergische Reaktionen vom Soforttyp auslösen können.',
      bullets: [
        '295 Allergen-Bluttest (+ bis zu 10 Bestätigungstests)',
        'Beurteilung und Empfehlungen des Allergologen',
        'Detaillierte Beschreibung des Allergenprofils',
        'Gelegenheit, zusätzliche Fragen zu stellen',
        '20-minütiges Videogespräch mit einem Allergologen'
      ],
      review: {
        auto: {
          title: 'Automatische Testauswertung',
          price: '+0 €',
          description: 'Wir werden prüfen, welche Allergene die von Ihnen genannten Symptome wahrscheinlich auslösen.'
        },
        written: {
          title: 'Schriftliche Beurteilung durch einen Arzt',
          price: '+29 €',
          description:
            'Der Allergologe wird Ihre Testergebnisse auswerten, kommentieren und schriftliche Empfehlungen aussprechen.'
        },
        consultation: {
          title: 'Ärztliche Beurteilung + Beratung',
          price: '+49 €',
          description:
            'Sie besprechen die Testergebnisse und den Behandlungsplan mit Ihrem Allergologen in einer Live-Fernsprechstunde und erhalten außerdem eine schriftliche Beurteilung.'
        }
      }
    },
    SCREENER: {
      allergens: '{allergensCount}',
      title: 'Primäres Allergie-Screening-Programm',
      titleResearch: '',
      titleProduct6month: '',
      orderTitle: 'Buchen Sie eine Erstuntersuchung',
      description:
        'Die Studie untersucht die Sensibilisierung {allergensCount} auf Allergene, die 95 % der allergischen Reaktionen schnellen Typs verursachen.',
      bullets: [
        'Allergen-Bluttest {allergensCount}',
        'Schriftliche Beurteilung und Empfehlungen durch einen Allergologen',
        'Gelegenheit, zusätzliche Fragen zu stellen',
        '20-minütiges Videogespräch mit einem Allergologen'
      ]
    },
    SCREENER_ASIT: {
      allergens: '{allergensCount}',
      title: 'AllergyChip',
      titleResearch: '',
      titleProduct6month: '',
      orderTitle: 'Buchen Sie einen AllergyChip-Test',
      description:
        'Die Studie untersucht die Sensibilisierung {allergensCount} auf Allergene, die 95 % der allergischen Reaktionen schnellen Typs verursachen.',
      bullets: [
        'Allergen-Bluttest {allergensCount}',
        'Schriftliche Beurteilung und Empfehlungen durch einen Allergologen',
        'Gelegenheit, zusätzliche Fragen zu stellen'
      ],
      review: {
        auto: {
          title: 'Automatische Testauswertung',
          price: '+0 €',
          description: 'Wir werden prüfen, welche Allergene die von Ihnen genannten Symptome wahrscheinlich auslösen.'
        },
        written: {
          title: 'Schriftliche Beurteilung durch einen Arzt',
          price: '+29 €',
          description:
            'Der Allergologe wird Ihre Testergebnisse auswerten, kommentieren und schriftliche Empfehlungen aussprechen.'
        },
        consultation: {
          title: 'Ärztliche Beurteilung + Beratung',
          price: '+59 €',
          description:
            'Sie besprechen die Testergebnisse und den Behandlungsplan mit Ihrem Allergologen in einer Live-Fernsprechstunde und erhalten außerdem eine schriftliche Beurteilung.'
        }
      }
    },
    FREE_SCREENER_ASIT: {
      allergens: '66',
      title: 'Primäres Allergie-Screening-Programm',
      titleResearch: '',
      titleProduct6month: '',
      orderTitle: 'Buchen Sie eine Erstuntersuchung',
      description:
        'Haben Sie spezielle Fragen zu Allergien und deren Behandlung? Unsere Ärzte helfen Ihnen, sie zu beantworten.',
      bullets: [
        'Schriftliche Beurteilung und Empfehlungen durch einen Allergologen',
        'Gelegenheit, zusätzliche Fragen zu stellen'
      ]
    },
    FREE_SCREENER: {
      allergens: '28',
      title: 'Primäres Allergie-Screening-Programm',
      titleResearch: '',
      titleProduct6month: '',
      orderTitle: 'Buchen Sie eine Erstuntersuchung',
      description:
        'Haben Sie spezielle Fragen zu Allergien und deren Behandlung? Unsere Ärzte helfen Ihnen, sie zu beantworten.',
      bullets: [
        'Schriftliche Beurteilung und Empfehlungen durch einen Allergologen',
        'Gelegenheit, zusätzliche Fragen zu stellen',
        '20-minütiges Videogespräch mit einem Allergologen'
      ]
    },
    IMMUNOTHERAPY_PLAN: {
      allergens: '295',
      title: 'Immuntherapieplan + Beratung',
      titleResearch: 'Ausführliche Allergietests zur Entwicklung eines Immuntherapieplans',
      titleProduct6month: '',
      orderTitle: 'Einen Behandlungsplan buchen',
      description: '..',
      bullets: ['..']
    },
    TREATMENT_PLAN: {
      allergens: '0',
      title: 'Immuntherapie-Behandlung für 3 Monate',
      titleResearch: '',
      titleProduct6month: 'Immuntherapie-Behandlung 6 Monate',
      orderTitle: 'Buchen Sie eine Fernbehandlung mit Immuntherapie',
      description: '..',
      bullets: ['..']
    },
    FOOD_ID: {
      allergens: '{allergensCount}',
      title: 'Untersuchung auf Lebensmittelunverträglichkeiten',
      titleResearch: '',
      titleProduct6month: '',
      orderTitle: 'Buchen Sie einen Lebensmittelunverträglichkeitstest',
      description: 'Die Studie untersucht die Sensibilisierung von {allergensCount} Lebensmitteln',
      bullets: ['{allergensCount} Allergenbluttest'],
      chat: {
        heading: 'Haben Sie Fragen?'
      },
      legend: {
        description:
          'Mit dem Nahrungsmittelunverträglichkeitstest wird die Anzahl der IgG-Antikörper im Blut gemessen. Diese Art der Sensibilisierung wird mit einer Nahrungsmittelunverträglichkeit in Verbindung gebracht. Je höher der Grad der Sensibilisierung, desto wahrscheinlicher ist es, dass das betreffende Lebensmittel Ihre Symptome auslöst. Eine Lebensmittelunverträglichkeit wird diagnostiziert, wenn ein Test eine übermäßige Sensibilisierung ergibt und das betreffende Lebensmittel Ihre Symptome auslöst.'
      },
      review: {
        auto: {
          title: 'Ich möchte keine Konsultation',
          price: '+0 €',
          description: 'Lassen Sie sich die Auswertung der Studie und die Empfehlungen schriftlich geben.'
        },
        written: {
          title: 'Schriftliche Beurteilung durch einen Arzt',
          price: '+29 €',
          description:
            'Der Allergologe wird Ihre Testergebnisse auswerten, kommentieren und schriftliche Empfehlungen abgeben.'
        },
        consultation: {
          title: 'Eine Konsultation hinzufügen',
          price: '+39 € (Normalpreis 49 €)',
          description:
            'Nach der Untersuchung beantwortet der Diätassistent Ihre Fragen und hilft Ihnen bei der Erstellung eines Plans zur Ernährungsumstellung.'
        }
      }
    },
    SCREENER_ASIT_SELFCO: {
      allergens: '{allergensCount}',
      title: 'Allergietest Self.co',
      titleResearch: '',
      titleProduct6month: '',
      orderTitle: 'Allergietest bestellen',
      description:
        'Der Test untersucht die Sensibilisierung gegen {allergensCount} Allergene, die 95% der allergischen Sofortreaktionen verursachen.',
      bullets: [
        '{allergensCount} Allergen-Bluttest',
        'Bewertung und schriftliche Empfehlungen des Allergologen',
        'Möglichkeit, zusätzliche Fragen zu stellen'
      ],
      review: {
        auto: {
          title: 'Automatische Testbewertung',
          price: '+0 €',
          description: 'Wir bewerten, welche Allergene wahrscheinlich die von Ihnen genannten Symptome hervorrufen.'
        },
        written: {
          title: 'Schriftliche Bewertung des Arztes',
          price: '+29 €',
          description:
            'Der Allergologe wird Ihre Testergebnisse bewerten und kommentieren und schriftliche Empfehlungen geben.'
        },
        consultation: {
          title: 'Ärztliche Bewertung + Beratung',
          price: '+49 €',
          description:
            'Sie besprechen die Testergebnisse und den Behandlungsplan mit dem Allergologen während einer Live-Fernkonsultation und erhalten auch eine schriftliche Bewertung.'
        }
      }
    },
    BUNDLE_SELFCO: {
      allergens: '{allergensCount}',
      title: 'Self.co Paket',
      titleResearch: '',
      titleProduct6month: '',
      orderTitle: 'Self.co Paket bestellen',
      description: 'Vollständiger Allergietest mit Arztberatung und sechsmonatigem Allergen-Immuntherapieplan.',
      bullets: [
        '{allergensCount} Allergen-Bluttest',
        'Allergologe-Bewertung und schriftliche Empfehlungen',
        '20-minütige Video-Konsultation mit Allergologe',
        '6-Monats-Allergen-Immuntherapieplan'
      ]
    }
  },
  features: {
    ourClinic: 'Allergomedica',
    privateClinic: 'Privatklinik',
    visits: {
      title: 'Anzahl der Besuche',
      hint1: 'Für Blutspenden in der nächstgelegenen Klinik',
      hint2: 'Spende Blut und finde die Antwort heraus'
    },
    timeToResult: {
      title: 'Zeit bis zur endgültigen Antwort nach der ersten Registrierung',
      tier1: '7 d.d.',
      tier2: 'ab 10 d.d.d.'
    },
    fullResearch: {
      title: 'Molekularer Bluttest'
    },
    screenerResearch: {
      title: 'Umfassender Allergie-Bluttest'
    },
    detailedProfile: {
      title: 'Ein von einem Allergologen erstelltes detailliertes Profil Ihrer Allergien'
    },
    recommendations: {
      title: 'Detaillierte schriftliche Anleitung'
    },
    questions: {
      title: 'Möglichkeit, zu einem späteren Zeitpunkt neue Fragen zu stellen'
    }
  },
  product: {
    title: 'Buchen Sie eine vollständige Studie',
    text: 'Mit unserem Programm können Sie detailliert feststellen, ob Ihre Symptome durch ein Allergen verursacht werden und welche Allergene die Symptome hervorrufen. Wir liefern eine detaillierte Analyse der Allergene sowie Empfehlungen und Behandlungsmöglichkeiten.',
    recommended: 'Wir empfehlen',
    comingSoon: 'Demnächst verfügbar',
    select: 'Wählen Sie'
  },
  allergo_expert: {
    title: 'Umfassendes Programm zur Allergiediagnostik',
    bullets: [
      'Beurteilung und Empfehlungen des Allergologen',
      'Detaillierte Beschreibung des Allergenprofils',
      'Fernberatung zur Beantwortung von Fragen',
      '295 Allergen-Bluttest (+ bis zu 10 Bestätigungstests)',
      'Wenn Sie weitere Fragen haben, haben Sie die Möglichkeit, unser Team zu fragen'
    ]
  },
  short_test: {
    scale_text: [
      'Keine Belastung',
      'Leichte Belastung',
      'Mäßige Belastung',
      'Schwerwiegende Belastung',
      'Sehr starke Belastung'
    ]
  },
  shortTestAnswer: {
    title: 'Vielen Dank, dass Sie den Fragebogen ausgefüllt haben.',
    description: {
      research:
        'Auf der Grundlage Ihrer Antworten wird Ihr Allergologe die genauesten Testmethoden auswählen und Ihnen maßgeschneiderte Empfehlungen geben, sobald die Ergebnisse vorliegen.',
      consultation:
        'Ihre Antworten ermöglichen es dem Arzt, sich vor der Konsultation ein besseres Bild von Ihrem Fall zu machen.'
    },
    weNeedYourAttention: 'Wir möchten Ihre Aufmerksamkeit auf Folgendes lenken',
    bookConsultation: 'Buchen Sie einen Termin für ein Beratungsgespräch',
    benefitsTitle: 'Was werden Sie lernen?',
    benefits: {
      SCREENER: [
        'Gegen welche der {allergensCount} häufigsten Allergene sind Sie allergisch?',
        'Welche Allergene können die von Ihnen genannten Symptome auslösen und welche sind klinisch irrelevant?',
        'Wie Sie Ihre Lebensqualität verbessern können, indem Sie Ihren Lebensstil anpassen',
        'Welche Behandlungsmöglichkeiten gibt es?'
      ],
      FULL: [
        'Auf welche der 295 häufigsten Allergene und ihre Moleküle sind Sie allergisch?',
        'Welche Allergene können die von Ihnen genannten Symptome auslösen und welche sind klinisch irrelevant?',
        'Wie Sie Ihre Lebensqualität verbessern können, indem Sie Ihren Lebensstil anpassen',
        'Welche Behandlungsmöglichkeiten gibt es für Sie, ist eine Immuntherapie für Sie geeignet?'
      ]
    },
    viewSample: {
      title: 'So sieht beispielsweise ein Testergebnis aus',
      button: 'Ansicht unter'
    },
    comparison: {
      title: 'Vergleichen Sie Allergomedica mit Privatkliniken',
      included: 'Abgerufen von',
      notIncluded: 'Nicht enthalten'
    },
    defaultProductTitle: 'Umfassendes Programm zur Allergiediagnostik'
  },
  allergyEvaluation: {
    subscribeAnswer: {
      title: 'Geben Sie Ihre E-Mail Adresse ein',
      description:
        'Um Ihnen den Zugang zum Fragebogen zu erleichtern, senden wir Ihnen einen Antwortlink an die von Ihnen angegebene E-Mail-Adresse.',
      buttonText: 'Kontakt'
    }
  },
  shortAnswer: {
    hello: 'Hallo,',
    title: 'Wir haben eine Allergiebeurteilung für Sie vorbereitet',
    description:
      'Die Auswertung basiert auf Statistiken von 2879 Personen, die bereits die Dienste von Allergomedica in Anspruch genommen haben. Auf der Grundlage dieser Daten haben wir die von Ihnen angegebenen Symptome bewertet und eine Allergiebeurteilung erstellt.',
    possibility: {
      title: 'Wahrscheinlichkeit einer Allergie vom Schnelltyp',
      items: {
        veryLow: 'Sehr niedrig',
        low: 'Niedrig',
        medium: 'Mittel',
        high: 'Hoch',
        veryHigh: 'Sehr hoch'
      },
      hint: 'Die Bewertung kann Ihnen bei der Entscheidung helfen, ob sich ein Allergietest lohnt, sollte aber nicht als medizinische Diagnose verwendet werden.'
    },
    allergens: {
      title: 'Häufige Allergene',
      text: 'Dies sind die Allergene, die am häufigsten die von Ihnen beschriebenen Symptome verursachen.',
      textNoAllergens:
        'Die von Ihnen genannten Symptome werden in der Regel nicht durch allergische Reaktionen vom schnellen Typ hervorgerufen.'
    },
    moreBlock: {
      title: 'Was nun?',
      items: {
        low: 'Die Wahrscheinlichkeit, dass Ihre Symptome durch eine unmittelbare Art von allergischer Reaktion hervorgerufen werden, ist gering. Wir empfehlen Ihnen, einen Facharzt zu konsultieren, um die Ursache Ihrer Symptome zu ermitteln.',
        high: 'Die Wahrscheinlichkeit ist groß, dass die Symptome, die Sie verspüren, durch eine allergische Reaktion vom Schnelltyp ausgelöst werden. Um sich testen zu lassen und Gewissheit zu erlangen, empfehlen wir einen ersten Allergietest.',
        veryHigh:
          'Es ist sehr wahrscheinlich, dass die bei Ihnen auftretenden Symptome durch eine allergische Reaktion vom Schnelltyp hervorgerufen werden. Eine genaue Diagnose kann jedoch nur durch einen Allergietest gestellt werden. Wir empfehlen, dass Sie sich einem umfassenden oder primären Allergietest unterziehen.'
      },
      hint: 'Die Bewertung kann Ihnen bei der Entscheidung helfen, ob sich ein Allergietest lohnt, sollte aber nicht als medizinische Diagnose verwendet werden.'
    },
    symptoms: {
      title: 'Die von Ihnen angegebenen Symptome',
      noSymptomsIndicated: 'Symptome nicht angegeben',
      noDetails: 'Unbenannt',
      items: {
        often: 'Häufig',
        common: 'Gewöhnlich',
        rare: 'Selten'
      },
      hint: 'Allergien können sich in einer Vielzahl von Symptomen äußern. Einige Symptome sind spezifisch und treten vor allem bei Allergien auf, während andere eher bei anderen Krankheiten vorkommen. Die Spezifität der Symptome hilft bei der Bestimmung des Allergierisikos.'
    },
    periodicity: {
      title: 'Periodizität',
      hint: 'Wiederkehrende Symptome sind ein häufiges Anzeichen für allergische Reaktionen. Wenn Sie eine Regelmäßigkeit feststellen, ist die Wahrscheinlichkeit einer Allergie höher.'
    },
    circumstances: {
      title: 'Hintergrund',
      hint: 'Schnelle Reaktionen treten unmittelbar nach dem Kontakt mit dem Allergen auf. Wenn Sie also die Umstände bemerken, die zu den Symptomen führen, erhöht dies die Wahrscheinlichkeit einer Allergie.'
    },
    duration: {
      title: 'Dauer der Symptome',
      items: {
        someMonth: 'Mehrere Monate',
        justNow: 'Was genau',
        fiveYear: '5+ Jahre'
      },
      hint: 'Wenn die Symptome über einen längeren Zeitraum anhalten und immer wieder auftreten, ist die Wahrscheinlichkeit von allergisch bedingten Symptomen höher.'
    }
  },
  test_answer: {
    navigation: {
      allergyProfile: 'Allergie-Profil',
      recommendations: 'Empfehlungen',
      allergens: 'Alle Allergene'
    },
    hello: 'Hallo,',
    hero_subtitle: 'Sie haben ein umfassendes Programm zur Beurteilung von Allergien durchlaufen.',
    hero_text: 'Sie haben in der Umfrage {num} angegeben Sie haben {tiring} und mögliche Allergien {relatedSymptoms}',
    yourAnswerIsNotReady: 'Wir freuen uns, dass Sie interessiert sind, aber Ihre Antwort ist noch nicht fertig.',
    youAreSensitive: 'Sie reagieren empfindlich auf',
    noSensitivity: 'Bei Ihnen ist keine Sensibilisierung diagnostiziert worden',
    allergenGroupPlural: 'Allergengruppe|Allergengruppen|allergene Gruppen',
    origin_of_symptoms: 'Ursprung der Symptome',
    here_we_review_diseases_and_symptoms:
      'Hier finden Sie einen Überblick über die Krankheiten und Symptome, die durch allergische Reaktionen verursacht werden können.',
    typical_symptoms: 'Typische Symptome',
    allergens: 'Allergene',
    possibly_provoking_symptoms: 'Potenziell provozierende Symptome',
    interpretation_of_sensitivity_intensity: 'Interpretation des Empfindlichkeitsgrads',
    no_symptoms: 'Keine damit verbundenen Symptome genannt',
    unclear_origin: 'Unbestimmten Ursprungs',
    doctorPosition: {
      LINAS: 'Leitender Allergologe und klinischer Immunologe',
      ANA: 'Allergologe',
      EGLE: 'Allergologe',
      AGNE: 'Ärztin, Oberärztin für Allergie und klinische Immunologie',
      KESTUTIS: 'Allergologe',
      LAIMA: 'Allergologe und klinischer Immunologe',
      GABIJA: 'Mediziner'
    },
    detailedAllergenProfile: {
      title: 'Ausführliches Allergenprofil',
      description:
        'Hier werden wir uns die möglichen Allergien, die wir bei der Blutuntersuchung festgestellt haben, im Detail ansehen und deren Zusammenhang und Bedeutung für Sie erklären.'
    },
    unidentifiedSymptoms: {
      title: 'Symptome unklarer Herkunft'
    },
    primaryAllergen: {
      title: 'Das Hauptallergen',
      tooltip:
        'Ein Allergen, das als Mitglied einer eigenen Gruppe angesehen wird (z. B. Baumpollen) und die häufigste Ursache für allergische Reaktionen ist. Dieses Allergen ist in der Regel das erste Allergen, gegen das eine Allergie entwickelt wird.'
    },
    noPrimaryAllergen: 'Kein Hauptallergen',
    components: {
      title: 'Komponenten',
      onlyInFullResult:
        'Einzelne Allergenkomponenten werden nur durch detaillierte molekulare Allergietests identifiziert.',
      tooltip:
        'In der Tat ist es nicht das gesamte Allergen, auf das eine Person sensibilisiert wird, sondern seine Bestandteile - die Komponenten. Ein einzelnes Allergen besteht in der Regel aus mehreren verschiedenen Komponenten, aber nicht alle seine Bestandteile haben allergene Eigenschaften. Eine Person kann gegen einen oder mehrere verschiedene Bestandteile des Allergens sensibilisiert sein. Die häufigsten Bestandteile sind Proteine. Die Bestandteile werden durch Symbole bezeichnet, die aus der lateinischen Abkürzung des Allergennamens und einer Zahl bestehen. Beispiel: Die erste Komponente von Birkenpollen (Betula verrucosa) wird als Bet v 1 bezeichnet. Die Komponenten helfen bei der Identifizierung der Hauptallergene, bei der Vorhersage des Risikos bestimmter allergischer Reaktionen und bei der Auswahl bestimmter Behandlungen.'
    },
    secondaryAllergens: {
      title: 'Andere assoziierte Allergene',
      onlyInFullResult:
        'Wir können verwandte Allergene und Kreuzreaktionen nur durch einen umfassenden molekularen Allergietest identifizieren',
      tooltip:
        'Allergene, die strukturelle Ähnlichkeiten mit dem Hauptallergen der Gruppe aufweisen und daher ebenfalls allergische Symptome hervorrufen können. In den meisten Fällen erfolgt die Sensibilisierung auf diese Allergene später als auf das Hauptallergen.'
    },
    relatedSymptoms: {
      title: 'Mögliche Symptome bei den folgenden Allergenen',
      tooltip:
        'Hier finden Sie alle möglichen Symptome, die durch diese Allergene verursacht werden können. Die hervorgehobenen Symptome haben Sie im Fragebogen als störend markiert'
    },
    activePeriod: {
      title: 'Relevanter Zeitraum',
      tooltip: 'Die oben genannten Allergene sind in dem unten genannten Zeitraum am häufigsten anzutreffen.',
      months: 'Die fettgedruckten Monate sind relevant'
    },
    viewAllAllergens: 'Alle auf {num} getesteten Allergene anzeigen',
    viewRecommendations: 'Empfehlungen ansehen',
    symptoms: 'Symptome',
    tiringPlural: 'Frustrierend|frustrierend|Frust',
    relatedSymptomsPlural: 'assoziiertes Symptom|assoziierte Symptome|zugeordnete Symptome',
    provokePlural: 'provoziert|provoziert|provoziert',
    symptomsPlural: 'Symptom|Symptom|Symptome',
    no_allergens: 'Keine provozierenden Allergene gefunden',
    sensitivity: [
      'Keine Empfindlichkeit',
      'Leichtes Einfühlungsvermögen',
      'Mittlere Empfindlichkeit',
      'Hohe Empfindlichkeit\n',
      'Hohe Empfindlichkeit'
    ],
    sensitivityShort: ['Nein', 'Einfach', 'Mittel', 'Hoch', 'Hoch'],
    sensitivitySuffix: 'die Folgendes hervorrufen können ',
    manySymptoms: 'viele Symptome',
    noSymptoms: 'die keine Symptome hervorrufen sollten',
    noSensitivityAllergensListTitle:
      'Sie wurden getestet, um eine mögliche Sensibilisierung auf {num} Allergene festzustellen'
  },
  recommendations: {
    title: 'Empfehlungen',
    titleActions: 'Beginnen Sie mit den folgenden Empfehlungen',
    titleAll: 'Alle Empfehlungen',
    otherRecommendations: 'Andere Empfehlungen',
    description:
      'Um Ihnen den Einstieg zu erleichtern, haben wir einige Lebensstil- und Behandlungsempfehlungen ausgewählt, die Ihre Lebensqualität verbessern können. Probieren Sie sie aus und prüfen Sie, ob Sie eine Verbesserung spüren. Auf der Grundlage Ihres Feedbacks werden wir die Empfehlungen aktualisieren, um sie an Sie anzupassen. Bitte beachten Sie, dass für einige der Empfehlungen die Beratung durch einen Allergologen erforderlich ist.',
    testedGood: 'Integrieren Sie diese Empfehlung in Ihren Lebensstil',
    testedBad: 'Wir werden nach anderen Möglichkeiten der Hilfe suchen',
    testedTime: 'Geprüft {date}',
    button: {
      work: 'Verfügbar unter',
      notWork: 'Funktioniert nicht',
      testedWork: 'Geprüft von',
      testedNotWork: 'Geprüft von'
    }
  },
  textPage: {
    remoteConsultation: {
      title: 'Regeln für die Fernabfrage'
    },
    privacyPolicy: {
      title: 'Datenschutzbestimmungen'
    },
    termsAndConditions: {
      title: 'Bedingungen der Dienstleistung'
    },
    signAgreement: {
      title: 'Unterzeichnung der Zustimmung'
    }
  },
  bloodRegistration: {
    title: 'Wählen Sie eine Klinik und eine Uhrzeit für die Blutabnahme',
    selectClinicStep: 'Wählen Sie eine Klinik',
    pickerPlaceholder: 'Wählen Sie...',
    completedTitle: 'Großartig!',
    completedLocation: 'Sie haben {title} ({address}) ausgewählt.',
    completedFurtherAction: 'Rufen Sie die Klinik per Telefon an:',
    completeFurtherActionSuffix: 'und vereinbaren Sie einen Termin für einen Besuch.',
    pickUpBoxPlaceholder: 'Suche nach einem Postamt...'
  },
  dashboard: {
    orderNewItem: 'Ein neues Programm buchen',
    title: 'Was nun?',
    noOrders: 'Sie scheinen keine Aufträge zu haben',
    descriptionNoBloodRegistration:
      'Anschließend müssen Sie sich in der Klinik Ihrer Wahl anmelden und Ihr Blut spenden.',
    descriptionNoBlood:
      'Alles, was Sie tun müssen, ist Ihr Blut zu spenden, und dann können wir den Test durchführen und die Ergebnisse auswerten.',
    tasks: {
      orderCompletedHeading: 'Ihr Ergebnis ist fertig',
      orderCompletedDescription:
        'Unsere Spezialisten haben einen Bluttest durchgeführt und die Ergebnisse ausgewertet. Sie können nun die Antwort auf den Test einsehen',
      orderCompletedDescriptionConsultation: 'Unsere Experten haben Empfehlungen für Sie vorbereitet.',
      incompleteHeading: 'Erledigen Sie die folgenden Aufgaben',
      completedHeading: 'Sie haben alle Aufgaben erledigt!',
      description:
        'Sobald unsere Experten den Test durchgeführt haben, werden wir Sie per E-Mail informieren {email}. Die Antwort auf die Umfrage finden Sie in der Rubrik "Antwort" oben.',
      giftCouponReady: 'Ihr Geschenkgutschein ist fertig'
    },
    bloodRegistration: {
      incompleteTitle: 'Melden Sie sich für einen Bluttest an',
      incompleteDescription:
        'Der Bluttest umfasst einen umfassenden Test auf 295 Allergene und bis zu 10 Bestätigungstests ',
      completed: 'Anmeldung zur Blutentnahme erfolgreich',
      callClinicByPhone: 'Rufen Sie die Klinik unter {phone} an, um einen passenden Termin zu vereinbaren.',
      completedDescription:
        'Für die Blutentnahme fallen keine zusätzlichen Kosten an. Bitte geben Sie in der Klinik an, dass Sie zur Blutabnahme für das Allergomedica-Allergieprogramm kommen und zeigen Sie die E-Mail mit der Bestätigung Ihrer Anmeldung vor.',
      selectedClinic: 'Die Klinik Ihrer Wahl:',
      selectedTime: 'Ihre Anmeldezeit:',
      button: 'Anmeldung unter'
    },
    research: {
      completed: 'Fragebogen erfolgreich ausgefüllt',
      description:
        'Reichen Sie Ihr Blut ein, wenn Sie es noch nicht getan haben, und wir informieren Sie, wenn die Antwort fertig ist.'
    },
    orderedAt: 'Gebucht:',
    orderId: 'Bestellnummer:',
    status: {
      ongoing: 'Laufend',
      completed: 'Implementiert'
    },
    order: 'Bestellung von',
    resultPreview: 'Antwort anzeigen'
  },
  form: {
    password: 'Passwort',
    email: 'E-Mail',
    surname: 'Nachname',
    name: 'Name',
    phone: 'Telefon',
    phoneNo: 'Rufnummer',
    birthDate: 'Datum der Geburt',
    placeholderBirthDate: 'Geben Sie Ihr Geburtsdatum ein',
    birthDateFormat: 'Verwenden Sie Bindestriche, um das Datum zu trennen, z. B. 1999-12-08',
    gender: 'Geschlecht',
    genderSelect: 'Wählen Sie Ihr Geschlecht',
    genderMale: 'Mann',
    genderFemale: 'Frau',
    genderPickerPlaceholder: 'Wählen Sie Ihr Geschlecht',
    personCode: 'Persönlicher Code',
    newPassword: 'Neues Passwort',
    repeatPassword: 'Wiederholen Sie Ihr Passwort',
    YourPersonalIdNo: 'Ihr persönlicher Code',
    YourChildCode: 'Die persönliche Identifikationsnummer Ihres Kindes',
    spouseName: 'Name des Ehepartners',
    spouseSurname: 'Nachname des Ehepartners',
    spouseEmail: 'E-Mail Adresse des Ehepartners',
    address: 'Adresse',
    city: 'Stadt',
    zipCode: 'Postleitzahl',
    atLeastEightSymbols: 'Mindestens 8 Zeichen',
    agreementForScienceResearch:
      'Ich bin damit einverstanden, dass meine persönlichen Daten und meine Blutprobe für wissenschaftliche Zwecke verwendet werden.',
    alertSuccessAnswer: {
      title: 'Erfolgreiche Registrierung',
      text: 'Vielen Dank! In der angegebenen E-Mail-Adresse finden Sie einen Link zu Ihrer Antwort.'
    },
    alertDangerAnswer: {
      title: 'Registrierung fehlgeschlagen',
      text: 'Sie haben die falsche E-Mail-Adresse eingegeben.'
    },
    requiredFields: 'Die mit * gekennzeichneten Felder sind Pflichtfelder.',
    country: 'Land'
  },
  diForm: {
    title: 'Bitte geben Sie den Teilnehmercode ein'
  },
  checkout: {
    success_title: 'Bestellung erfolgreich',
    success_text:
      'Eine Bestätigungs-E-Mail wurde an Ihre Adresse gesendet. Wir bereiten nun den Versand Ihres Blutentnahmesets vor. In der Zwischenzeit können Sie den Fragebogen ausfüllen, den wir zur Erstellung Ihres Berichts verwenden werden. Sie können ihn auch später ausfüllen.',
    sign_success_title: 'Das Dokument wurde erfolgreich signiert',
    sign_success_text:
      'Sie haben ein Schreiben zur Bestätigung Ihres Abonnements an die folgende E-Mail-Adresse erhalten',
    titleContactInfo: 'Kontaktinformationen',
    titleSpouseContactInfo: 'Kontaktinformationen des Ehepartners',
    titleChooseBank: 'Wählen Sie Ihre Zahlungsmethode',
    titleInfoForRemoteConsultation: 'Informationen für eine Fernberatung',
    explanationTextInfoForRemoteConsultation:
      'Für verschreibungspflichtige Arzneimittel und für die Eingabe Ihrer Konsultation in eHealth ist ein persönlicher Code erforderlich.',
    explanationTextInfoForChildsResearch:
      'Für Kinder unter 12 Jahren ist die Zustimmung beider Elternteile erforderlich. Wir werden Ihnen einen Link zur elektronischen Unterzeichnung des Dokuments an die angegebene E-Mail-Adresse senden.',
    failed: {
      title: 'Bestellung fehlgeschlagen',
      description: 'Wir konnten Ihre Zahlung nicht erhalten. Bitte versuchen Sie es erneut, oder kontaktieren Sie uns'
    },
    loginTitle: 'Bei Ihrem Konto anmelden',
    loginDescription:
      'Wenn Sie sich bereits in der Vergangenheit bei uns registriert haben, loggen Sie sich in Ihr Konto ein, um den Status Ihres Programms zu verfolgen und weitere Maßnahmen zu ergreifen',
    titleYourOrder: 'Ihre Bestellung',
    titleBilling: 'Kasse',
    hide: 'Ausblenden',
    iHaveDiscount: 'Ich habe einen Rabattcode',
    discount: 'Rabatt',
    subTotal: 'Zwischensumme',
    discountCode: 'Rabattcode',
    amount: 'Gesamtbetrag',
    checkboxIHaveReadAnd: 'Ich habe es gelesen und bin damit einverstanden',
    checkboxPrivacyPolicy: 'Datenschutzbestimmungen',
    checkboxAnd: 'und',
    checkBoxTermsOfService: 'Allgemeine Geschäftsbedingungen',
    checkboxIAgreeThatImunodiagnostika:
      'Ich stimme der Verarbeitung meiner Gesundheitsdaten durch Immunodiagnostics, UAB zum Zweck der Erstellung eines Kontos, der Durchführung von Tests und der Bereitstellung von Gesundheitsbewertungen und Empfehlungen zu.',
    checkboxIAgreeToGetDoctorAdvice:
      'Ich bin damit einverstanden, von meinem Arzt Ratschläge zum Leben mit Allergien, Gesundheitsnachrichten und Sonderangebote zu erhalten. Sie können sich jederzeit einfach wieder abmelden.',
    checkboxPayseraText:
      'Bitte beachten Sie, dass Kontoinformationen und Zahlungsauslösedienste von Paysera in Übereinstimmung mit den folgenden Nutzungsbedingungen zur Verfügung gestellt werden',
    checkboxPayseraTerms: 'Regeln',
    checkboxPayseraAgreement:
      '. Indem Sie die Zahlung fortsetzen, bestätigen Sie, dass Sie die Bereitstellung dieser Dienste und deren Bedingungen akzeptieren.',
    checkboxAgreeRemoteConsultation: 'Ich habe gelesen und bin einverstanden mit ',
    checkboxAgreeRemoteConsultationSuffix: 'die Regeln für die Telekonsultation.',
    checkboxAgreeChildResponsibility:
      'Ich bestätige, dass ich die Person bin, die berechtigt ist, gesundheitliche Entscheidungen für das Kind zu treffen.',
    previewProfile: 'Zum Profil',
    titleResearch: 'Unterzeichnung der Zustimmung',
    SigningOfDocumentsDokobit: 'Die Unterzeichnung der Dokumente wird über das Dokobit-System erfolgen.',
    showOrder: 'Bestellung anzeigen',
    fillQuestionnaire: 'Füllen Sie den Fragebogen aus',
    checkBoxAgreeAll: 'Alle Wahlmöglichkeiten akzeptieren',
    dataIsSecured: '&#x1F512; Ihre Daten sind sicher.',
    bundle_success_title: '',
    bundle_success_text: ''
  },
  registration: {
    title: 'Ein Konto erstellen',
    text: 'Sobald Sie ein Konto erstellt haben, können Sie mit Ihrer App fortfahren und erhalten später die Ergebnisse des Tests',
    haveAccount: 'Sie haben bereits ein Konto?',
    login: 'Anmelden'
  },
  login: {
    title: 'Anmelden',
    forgotYourPasswordLink: 'Haben Sie Ihr Passwort vergessen?',
    dontHaveAccount: 'Sie haben noch kein Konto?',
    register: 'Anmeldung unter'
  },
  forgotPassword: {
    requestPasswordReset: 'Passwort vergessen',
    successTitle: 'Passwort-Erinnerungslink, der an die von Ihnen angegebene E-Mail-Adresse gesendet wird',
    finishPasswordReset: 'Ändern Sie Ihr Passwort',
    changePasswordSuccessTitle: 'Passwort aktualisiert',
    linkToLogin: 'Zurück zur Anmeldung'
  },
  selectPatient: {
    title: 'Wählen Sie aus, wer getestet werden soll:',
    label: 'Wählen Sie aus der folgenden Liste oder fügen Sie eine neue hinzu.',
    labelRadio: 'Wählen Sie einen Patienten oder legen Sie einen neuen Patienten an',
    addNewPatient: 'Einen neuen Patienten hinzufügen',
    button: 'Weiter'
  },
  createPatient: {
    title: 'Zusätzliche Informationen für Patienten',
    label: 'Es werden Tests durchgeführt:',
    addNewPatient: 'Einen neuen Patienten hinzufügen',
    button: 'Weiter',
    agreementForSienceResearch: 'Weiter'
  },
  createPatientChild: {
    title: 'Zusätzliche Informationen über Ihr Kind',
    label: 'Es werden Tests durchgeführt:',
    addNewPatient: 'Einen neuen Patienten hinzufügen',
    button: 'Weiter'
  },
  navigation: {
    orders: 'Bestellstatus',
    result: 'Ergebnisse',
    consultations: 'Informationen und Fragen',
    yourProfile: 'Mein Profil',
    signOut: 'Abmelden',
    selectItem: 'Wählen Sie eine Seite',
    comingSoon: 'Demnächst verfügbar',
    openMainMenu: 'Öffnen Sie das Hauptmenü',
    languages: {
      en: 'English',
      de: 'Deutsch'
    }
  },
  profileAllergens: {
    weHaveEvaluated: 'Insgesamt haben wir Folgendes bewertet',
    allergensTotal: ' Allergene',
    footnotes: {
      prefix: 'Die Quelle der Bluttestdaten finden Sie unter',
      link: 'hier',
      suffix: '(Sie können die Antwort durch Eingabe des Geburtsdatums des Patienten sehen)'
    },
    table: {
      allergen: 'Allergen',
      component: 'Komponente',
      biochemicalDesignation: 'Protein-Gruppe',
      value: 'Bedeutung',
      strength: 'Stärke'
    },
    title: {
      researchOverview: 'Überblick über die Studie',
      researchResults: 'Ergebnisse der Umfrage'
    },
    tableOverview: {
      group: 'Gruppe',
      amount: 'Anzahl der Analyten'
    }
  },
  legend: {
    title: 'Interpretation des Empfindlichkeitsgrads',
    description:
      'Die Stärke der Sensibilisierung sagt nicht direkt etwas darüber aus, ob das reagierende Allergen tatsächlich Symptome verursacht. Je stärker die Sensibilisierung jedoch ist, desto wahrscheinlicher ist es, dass der Befund klinisch bedeutsam ist.',
    senseHigh: 'Hohe Sensibilisierung (>3,5 kU/l)',
    senseMedium: 'Mittlere Sensibilisierung (0,7 - 3,49 kU/l)',
    senseLow: 'Leichte Sensibilisierung (0,35 - 0,69 kU/l)',
    senseNone: 'Keine Sensibilisierung (0 - 0,34 kU/l)',
    noNum: {
      senseHigh: 'Hohe Empfindlichkeit\n',
      senseMedium: 'Mittlere Empfindlichkeit',
      senseLow: 'Geringe Empfindlichkeit',
      senseNone: 'Keine Empfindlichkeit'
    }
  },
  order: {
    steps: ['Füllen Sie den Fragebogen aus', 'Bezahlen ', 'Blut spenden', 'Erhalten Sie Ihre Antwort'],
    stepsConsultation: [
      'Füllen Sie den Fragebogen aus',
      'Bezahlen ',
      'Kontaktieren Sie Ihren Arzt',
      'Empfehlungen erhalten'
    ],
    stepsResearch: [
      'Füllen Sie den Fragebogen aus',
      'Unterschreiben Sie die Zustimmung',
      'Blut spenden',
      'Erhalten Sie Ihre Antwort'
    ],
    stepsImmunotherapy: [
      'Füllen Sie den Fragebogen aus',
      'Bezahlen ',
      'Blut spenden',
      'Wir erstellen einen Behandlungsplan'
    ],
    stepsQuestionnaireAfterSale: [
      'Bezahlen ',
      'Füllen Sie den Fragebogen aus',
      'Blut spenden',
      'Erhalten Sie Ihre Antwort'
    ],
    stepsBundle: ['Bundle bestellen', 'Weitere Anweisungen erhalten', 'Onboarding abschließen', 'Ergebnisse erhalten']
  },
  chat: {
    inputPlaceholder: 'Ihre Nachricht...',
    heading: 'Haben Sie Fragen zu Ihren Allergien?',
    headingHasDr: 'Noch Fragen?',
    description: 'Fragen Sie sie an unsere Experten',
    descriptionHasDrPlural: 'Ihr Arzt|Ihre Ärzte',
    replyTimeDescription: 'Wir antworten in der Regel innerhalb weniger Stunden.',
    doctorsTitle: 'Unser Ärzteteam',
    consultation: {
      title: 'Fernberatung',
      description: 'Möchten Sie Ihre Fragen in einer Fernberatung besprechen? Die erste Beratung ist kostenlos.',
      button: 'Anmeldung unter'
    }
  },
  questionnaireConsultationIntro:
    'Wir garantieren Ihnen, dass Sie innerhalb von 2 Werktagen nach Zahlungseingang eine Beratung erhalten.',
  questionnaireGenericIntro:
    'Füllen Sie den Fragebogen aus und wir beraten Sie, welches Allergomedica-Allergietestprogramm für Sie am besten geeignet ist',
  questionnaireCheckAllergyIntro:
    'Haben Sie den Verdacht, dass Sie allergisch sind? Dieser Fragebogen hilft Ihnen, die Wahrscheinlichkeit einzuschätzen, dass Ihre Symptome durch eine allergische Reaktion vom Schnelltyp verursacht werden.',
  questionnaireDuration: 'Die Umfrage dauert bis zu 5 Minuten.',
  doctors: [
    {
      name: 'Linas Griguola',
      nameAccusative: 'Lino Griguola',
      role: 'Leitender Allergologe und klinischer Immunologe',
      subrole: '"Oberarzt bei Allergomedica',
      imageUrl: 'LINAS',
      infoLink: 'linas-griguola'
    },
    {
      name: 'Ana Kozlovska',
      nameAccusative: 'Anna Kozlovska',
      role: 'Allergologe und klinischer Immunologe; pädiatrischer Allergologe',
      subrole: '"Allergomedica Arzt',
      imageUrl: 'ANA',
      infoLink: 'ana-kozlova'
    },
    {
      name: 'Eglė Žilėnaitė',
      role: 'Allergologe und klinischer Immunologe',
      subrole: '"Allergomedica Arzt',
      imageUrl: 'EGLE',
      infoLink: 'Egelzilenait'
    },
    {
      name: 'Kęstutis Černiauskas',
      role: 'Allergologe und klinischer Immunologe',
      subrole: '"Allergomedica Arzt',
      imageUrl: 'KESTUTIS',
      infoLink: 'kestutis-cerniauskas'
    },
    {
      name: 'Laima Aleksandravičiūtė',
      role: 'Allergologe und klinischer Immunologe',
      subrole: '"Allergomedica Arzt',
      imageUrl: 'LAIMA',
      infoLink: 'laima-aleksandraviciute'
    }
  ],
  reviewsBanner: {
    title: 'Was halten Sie von {companyName}?',
    text: 'Wir wären Ihnen sehr dankbar, wenn Sie uns Ihre Gedanken mitteilen könnten. Es wird 1-2 Minuten dauern.',
    button: 'Mehr lesen',
    dismiss: 'Schließen'
  },
  consultationBanner: {
    title: 'Möchten Sie einen Weg finden, um Ihre Symptome zu lindern oder zu heilen? Oder brauchen Sie nur einen Rat?',
    text: 'Fügen Sie eine Fernkonsultation mit einem Arzt für eine vollständige Untersuchung hinzu. Während der Konsultation können Sie die\ndie Ergebnisse der Untersuchung besprechen und einen Behandlungsplan erstellen. Sie können dies während des Buchungsvorgangs tun.'
  },
  feedback: {
    success_title: 'Danke, dass Sie uns helfen, uns zu verbessern!',
    success_text: 'Ihre Antwort wurde erfolgreich gesendet.'
  },
  consultationSuccess: {
    success_title: 'Ich danke Ihnen!',
    success_text: 'Ihre Registrierung ist erfolgreich'
  },
  calendar: {
    title: 'Freie Zeit des Arztes',
    freeTime: 'Zeiten',
    titleFreeTime: 'Freie Zeiten - ',
    previousMonth: 'Letzter Monat',
    nextMonth: 'Nächster Monat',
    noAppointments: 'Keine Freistellung',
    schedule: 'Der Zeitplan ist für',
    showDates: 'Termine anzeigen',
    weekDays: {
      M: 'P',
      Tue: 'A',
      W: 'T',
      T: 'K',
      F: 'P',
      S: 'Š',
      Su: 'S'
    }
  },
  immunotherapy: {
    titleTreatment: 'Zustimmung zum Beginn der Behandlung',
    titleAddress: 'Adresse für die Lieferung von Arzneimitteln',
    subTitleAddress: 'An welche Adresse möchten Sie Ihre Medikamente erhalten?',
    form: {
      terms: {
        firstRow: 'Ich stimme einer ASIT-Behandlung zu.',
        firstRowChild: 'Ich bin damit einverstanden, dass mein Kind mit ASIT behandelt wird.',
        secondRow: 'Ich bin vertraut mit ',
        secondRowLinkText: 'Behandlungsprotokoll.',
        items: [
          'Ich bin mir über den Zweck der geplanten Behandlung, ihre Dauer, ihre Wirksamkeit und die Möglichkeit von unerwünschten Wirkungen bewusst;',
          'Ich informierte sie über meine Krankheiten und die Medikamente, die ich einnahm;',
          'Ich habe Fragen zu dieser Behandlungsmethode gestellt und Antworten erhalten;'
        ],
        itemsChild: [
          'Ich bin mir über den Zweck der geplanten Behandlung, ihre Dauer, ihre Wirksamkeit und die Möglichkeit von unerwünschten Wirkungen bewusst;',
          'Ich habe sie über die Krankheiten meines Kindes und die Medikamente, die es einnimmt, informiert;',
          'Ich habe Fragen zu dieser Behandlungsmethode gestellt und Antworten erhalten;'
        ]
      }
    },
    successText: 'Umfragedaten gespeichert.',
    treatmentPlan: {
      title: 'Behandlungsplan',
      titleDuration: 'Verbleibende Zeit zur Überprüfung Ihres Behandlungsplans',
      subtitleAllergenPlural: 'Allergene|Allergene',
      subtitleSymptoms: 'Symptome',
      subtitleDrugsForSymptoms: 'Medikamente zur Linderung von Symptomen'
    },
    treatmentProgress: {
      title: 'Fortschritte bei der Behandlung',
      titleSymptoms: 'Schwere des Symptoms',
      titleProgressBlock: 'Allgemeine Fortschritte',
      titleChart: 'Veränderung der Symptomschwere im Laufe der Zeit',
      chartText: 'Behandlungsfortschritt in %'
    },
    treatmentDayPlural: 'Tag|Tage|Tage',
    tabs: {
      ask: 'Fragen Sie',
      progress: 'Fortschritt',
      plan: 'Plan'
    }
  },
  anamnesis: {
    questionnaire: {
      description:
        'Füllen Sie vor Ihrem Termin einen Fragebogen über die Symptome aus, unter denen Sie leiden. So können wir uns ein besseres Bild von Ihrer Situation machen und die Zeit in der Sprechstunde besser nutzen.',
      submit: {
        title: 'Senden Sie die Umfragedaten',
        privacypolicy1: 'Wenn Sie auf "Senden" klicken, stimmen Sie der Weitergabe Ihrer Daten zu',
        privacypolicy1IsSecond: 'Wenn Sie auf "Fertig stellen" klicken, stimmen Sie der Weitergabe Ihrer Daten zu',
        privacypolicy2: 'zustimmen',
        privacypolicyLinkTex: 'System-Datenschutzerklärung',
        termsAndConditions1: 'und ',
        termsAndConditionsLinkText: 'Nutzungsbedingungen.',
        isSecond: {
          title: 'Danke, in diesem Fall brauchen Sie den Fragebogen nicht auszufüllen.',
          title2: 'Ihr Arzt ist bereits mit Ihrer Situation vertraut.'
        }
      },
      successTitle: 'Ihr Fragebogen wurde erfolgreich an Ihren Arzt weitergeleitet',
      error: 'Senden nicht möglich',
      upload: {
        title: 'Zusätzliche Informationen hochladen',
        description:
          'Laden Sie zusätzliche Informationen hoch, damit Ihr Arzt Ihre Situation schneller beurteilen kann:',
        list: [' Fotos der Hautsymptome, die bei Ihnen auftreten.', 'Ergebnisse von Allergietests'],
        success: 'Ihre Daten wurden erfolgreich an Ihren Arzt übermittelt',
        noPatientTitle: 'Falscher Link.',
        noPatientText: 'Wenden Sie sich an Ihren behandelnden Arzt.'
      }
    }
  },
  selectConsultationReview: {
    title: 'Wählen Sie, wie Sie die Ergebnisse auswerten wollen:'
  },
  treatmentProtocol: {
    title: 'Behandlungsprotokoll'
  },
  locations: {
    workingHours: 'Öffnungszeiten:'
  },
  meta: {
    description:
      'Modernste Diagnose und Behandlung von allergischen Erkrankungen. Allergietests und Allergentests bequem von zu Hause aus. Allergomedica - für ein Leben ohne Allergien.',
    title: 'AllergoMedica - Der moderne Weg zum Verständnis Ihrer Allergien.',
    url: 'https://app.allergomedica.lt'
  },
  footer: {
    companyInfo: 'Imunodiagnostika, UAB Unternehmenscode: 303064228',
    address: 'Molėtų g. 16, Didžiosios Riešės k., LT-14260 Vilniaus r.',
    phone: '+370 640 65680',
    email: 'info@allergomedica.lt'
  },
  FOOD_ID: {
    test_answer: {
      navigation: {
        allergyProfile: 'Übersicht',
        recommendations: 'Empfehlungen',
        allergens: 'Testergebnisse – Lebensmittelunverträglichkeiten'
      },
      hello: 'Hallo,',
      hero_subtitle: 'Überblick über Ihre Situation',
      hero_text:
        'Sie haben in der Umfrage {num} angegeben Sie haben {tiring} und möglicherweise Allergien {relatedSymptoms}',
      summary: {
        weight: 'Gewicht',
        kg: 'kg',
        height: 'Größe',
        bmi: 'Body Mass Index',
        BMI: 'BMI',
        cm: 'cm'
      },
      youAreSensitive: 'Sie reagieren empfindlich auf',
      noSensitivity: 'Bei Ihnen wurde keine Sensibilisierung gegen die getesteten Lebensmittel diagnostiziert.',
      allergenGroupPlural: 'Lebensmittel|Lebensmittelprodukt|Lebensmittelprodukte.',
      yourSymptoms: 'Ihre Symptome',
      profileAllergens: {
        weHaveEvaluated: 'Gesamter Lebensmittelunverträglichkeitstest:',
        allergensTotal: 'Produkte',
        table: {
          allergen: 'Lebensmittel',
          strength: 'Klasse/Stärke der Sensibilisierung'
        }
      },
      habits: {
        youAreSensitivePlural: 'Für Sie eingestellt|Für Sie eingestellt|Für Sie eingestellt',
        noHabits: 'Sie haben keine bestimmten Ernährungs- oder Lebensgewohnheiten, die Ihre Symptome auslösen könnten.',
        habitsPlural:
          'Ernährungs- und Lebensstilgewohnheiten|Ernährung und Lebensstilgewohnheiten|Ernährung und Lebensstilgewohnheiten.',
        canProvokeSymptoms: ', die Symptome hervorrufen können.',
        canProvokeYou: 'Kann provozieren',
        symptoms: 'Symptome',
        youAreSensitiveStaticTitle:
          'Die von Ihnen identifizierten Ernährungs- und Lebensgewohnheiten, die Ihre Symptome verursachen könnten',
        canProvokeYouPlural: 'Kann bei Ihnen die folgenden Symptome hervorrufen'
      },
      symptoms: {
        title: 'Schauen wir uns die von Ihnen genannten Symptome an',
        titleHabitsThatCanProvokeSymptom: 'Gewohnheiten, die dieses Symptom hervorrufen können:',
        titleFoodThatCanProvokeSymptom: 'Nahrungsmittel, die dieses Symptom hervorrufen können:',
        titleOtherFactors: 'Andere Faktoren:',
        factoriesWhich: 'Faktoren, die'
      },
      emptyState:
        'Um eine Auswertung der Studie und Empfehlungen zu erhalten, füllen Sie bitte den Fragebogen aus. Die Antwort auf den Fragebogen finden Sie im Abschnitt "Umfrageantwort".',
      emptyStateRecommendationsTitle: 'Fragebogen noch nicht ausgefüllt',
      emptyStateRecommendations:
        'Während der Vorbereitung Ihrer Studie füllen Sie bitte einen Fragebogen zu Ihren Beschwerden und Ernährungsgewohnheiten aus, damit wir individuelle Ernährungsempfehlungen für Sie erstellen können.',
      emptyStateRecommendationsText:
        'Während Ihr Test vorbereitet wird, füllen Sie bitte den Fragebogen zu Ihren Beschwerden aus, damit wir personalisierte Empfehlungen für Sie erstellen können.'
    },
    recommendations: {
      title: 'Empfehlungen',
      description:
        'Speziell für Sie ausgewählte Änderungen der Ernährungs- und Lebensgewohnheiten, die zur Verbesserung Ihres Wohlbefindens beitragen können.',
      titleProducts: 'Produkte, die wir empfehlen, zu reduzieren oder zu ersetzen',
      titleProductSymptoms: 'Ausgelöste Symptome:',
      titleHowToAvoid: 'Wie lässt sich dies vermeiden?',
      titleHowToFollowRecommendations: 'Wie sind die Empfehlungen zu befolgen?',
      textHowToFollowRecommendations:
        'Wenn diese Empfehlungen die Beschwerden nicht innerhalb von 3–4 Wochen lindern oder während dieser Zeit Alarmsymptome auftreten, wenden Sie sich bitte umgehend an Ihren Hausarzt oder Gastroenterologen, um eine genauere Untersuchung durchführen zu lassen.'
    },
    footer: {
      email: 'info@foodid.lt'
    },
    button: {
      showAll: 'Alle anzeigen',
      showLess: 'Weniger anzeigen'
    }
  },
  years: '{age} m.',
  testResults: {
    protocolNumber: 'Prüfbericht Nr.',
    testTitle: 'Studientitel:',
    nameSurname: 'Vorname und Nachname:',
    gender: 'Geschlecht:',
    birthDate: 'Geburtsdatum:',
    sampleDateTime: 'Datum und Uhrzeit der Probenahme:',
    laboratoryDateTime: 'Datum und Uhrzeit des Probeneingangs im Labor:',
    testDateTime: 'Datum und Uhrzeit des Restes der Studie:',
    resultsDateTime: 'Datum und Uhrzeit der Ergebnisfreigabe:',
    sampleTypes: 'Probenart:',
    sampleCode: 'Beispiel-Code:',
    method: 'Methode:',
    testPerformedBy: 'Analyse durchgeführt von:',
    testResultsConfirmed: 'Ergebnisse bestätigt von:'
  },
  doctorSelection: {
    pickerPlaceholder: 'Die Wahl eines Arztes...',
    doNotWantToShare: 'Ich möchte keine Informationen an den Arzt weitergeben'
  },
  questionnaire: {
    success: {
      title: 'Fragebogen erfolgreich ausgefüllt'
    },
    bloodCollectionNote: 'Die Blutentnahme ist bereits im Testpreis enthalten'
  },
  shipment: {
    title: 'Geben Sie Ihre Lieferadresse ein',
    subtitle:
      'Wir schicken Ihr Blutentnahme-Set an diese Adresse. Bitte vergewissern Sie sich, dass Ihre Angaben korrekt sind.'
  },
  option: {
    rarelyOrNever: 'Selten oder nie',
    yes: 'Ja',
    no: 'Nein',
    dontKnow: 'Weiß nicht',
    medication: {
      antihistamine: 'Antihistaminika-Tabletten / Sirupe',
      nasalSpray: 'Nasenspray (gegen Verstopfung)',
      nasalHormonal: 'Hormonelles Nasenspray',
      eyeDrops: 'Augentropfen',
      inhaler: 'Inhalatoren (für die Lunge)',
      hormonalAntiInflammatory: 'Hormonelle entzündungshemmende Medikamente (z.B. Dexamethason)'
    },
    goal: {
      checkNewAllergies: 'Ich möchte überprüfen, ob neue Allergien aufgetreten sind'
    }
  },
  onboarding: {
    p58: {
      heading: 'Füllen Sie den Fragebogen aus'
    },
    bundle: {
      heading: 'Vielen Dank!'
    }
  },
  questions: {
    p58: {
      description: {
        intro:
          'Füllen Sie einen Fragebogen über Ihre Beschwerden und Ihre Essgewohnheiten aus. Anhand dieser Informationen wird ein Überblick über Ihre Ernährungsgewohnheiten erstellt und es werden maßgeschneiderte Ernährungsempfehlungen für Sie erarbeitet.'
      }
    },
    bundle: {
      description: {
        welcome:
          'Sie haben das vollständige Test-Paket ausgewählt. Klicken Sie auf Weiter, um Ihren Kauf abzuschließen.'
      }
    }
  }
};
